import React from 'react';
import { IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

/**
 * Reusable help icon button
 * @param {function} onClick - Click handler
 * @param {object} sx - Optional MUI sx prop for styling
 */
export default function HelpIcon({ onClick, sx = {} }) {
  return (
    <IconButton
      size="small"
      aria-label="help"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      sx={{ p: 0, ml: 0.5, ...sx }}
    >
      <HelpOutlineIcon sx={{ fontSize: 16 }} />
    </IconButton>
  );
}

